export default{

	controller: false,

	init(){
		this.controller = new ScrollMagic.Controller();
		// this.initNavigationScene();
		// this.initHeaderScene(); 
		this.initEntryScene();
		this.initHistoryScene();
		this.initMonitorsScene();
		this.initRandoScene();
		this.initPensionScene();
		this.initEvelageScene();
		this.initHorsesScene();
		// this.initMethodScene();
		// this.initSaleScene();
	},


	initEntryScene(){
		var tween = new TimelineMax();

		tween.fromTo('#discover .front-entry-content-left', 0.8, {y: '20%', opacity: 0}, {y: '0%', opacity: 1, ease: Power2.easeOut})
		tween.fromTo('#discover .front-entry-slider-wrap', 0.8, {opacity: 0}, {opacity: 1, ease: Power2.easeOut})


		this.entryScene = new ScrollMagic.Scene({
			triggerElement: '#discover',
			// triggerHook: 'onEnter',
		})
		.setTween(tween)
		.addTo(this.controller)

		// this.entryScene.addIndicators();
	},


	initHistoryScene(){
		var tween = new TimelineMax();

		// tween.fromTo('#history h2', 0.8, {y: '20%', opacity: 0}, {y: '0%', opacity: 1, ease: Power2.easeOut})
		// tween.fromTo('#pains a', 0.8, {y: '20%', opacity: 0}, {y: '0%', opacity: 1, ease: Power2.easeOut}, 0.2)
		tween.from('#historyLeft', 1, {y: '40%' , ease: Power0.easeOut});
		// tween.fromTo('#history .front-history-content h2', 1, {y: '20%'}, {y: '-10%', ease: Power0.easeOut});
		tween.fromTo('#history .front-history-content', 1, {y: '20%', opacity: 0.4}, {opacity: 1, y: '-10%', ease: Power0.easeOut}, 0);



		this.ourBreadsScene = new ScrollMagic.Scene({
			triggerElement: '#history',
			// triggerHook: 'onEnter',
			offset: 0,
			duration: 300
		})
		.setTween(tween)
		.addTo(this.controller)

		// this.ourBreadsScene.addIndicators();
	},

	initMonitorsScene(){
		var tween = new TimelineMax();

		tween.fromTo('#monitors h3', 0.5, {y: '20%', opacity: 0}, {opacity: 1, y: '0%', ease: Power2.easeOut}, 0);
		tween.staggerFromTo('#monitors .front-monitor', 1, {y: '10%', opacity: 0}, {y: '0%', opacity: 1, ease: Power2.easeOut}, 0.25);



		this.ourBreadsScene = new ScrollMagic.Scene({
			triggerElement: '#monitors',
			// triggerHook: 'onEnter',
			offset: -100,
			// duration: '50%'
		})
		.setTween(tween)
		.addTo(this.controller)

		// this.ourBreadsScene.addIndicators();
	},

	initRandoScene(){

		var tween = new TimelineMax();

		tween.fromTo('#randoImage', 1, {y: '40%'}, {y: '-20%', ease: Power0.easeNone})
		tween.fromTo('#randonnees h2', 0.8, {y: '20%', opacity: 0}, {y: '0%', opacity: 1, ease: Power2.easeOut}, 0)
		tween.fromTo('#randonnees .rando-left', 0.6, {y: '10%', opacity: 0}, {y: '-20%', opacity: 1, ease: Power2.easeOut }, 0.2)
		
		tween.fromTo('#randonnees .rando-bubble-one', 0.8, {y: '150%'}, {y: '-100%',  ease: Power2.easeOut}, 0)
		tween.fromTo('#randonnees .rando-bubble-two', 0.8, {y: '200%'}, {y: '-30%',  ease: Power2.easeOut}, 0)
		tween.fromTo('#randonnees .rando-bubble-three', 0.8, {y: '120%'}, {y: '-10%', opacity: 1, ease: Power2.easeOut}, 0)


		this.engagementScene = new ScrollMagic.Scene({
			triggerElement: '#randonnees',
			// triggerHook: 'onEnter',
			offset: 50,
			duration: '50%'
		})
		.setTween(tween)
		.addTo(this.controller)

		// this.engagementScene.addIndicators();

	},


	initPensionScene(){
		var tween = new TimelineMax();

		// tween.fromTo('#pension h2', 0.8, {x: -40, opacity: 0}, {x: '0%', opacity: 1, ease: Power2.easeOut})
		tween.fromTo('#pensionImage', 1.4, {y: '30%', opacity: 0}, { y: '0%', opacity: 1, ease: Power2.easeOut})
		tween.fromTo('#pension .pension-right', 1, {y: '20%', opacity: 0}, { y: '0%', opacity: 1, ease: Power2.easeOut}, 0)

		tween.fromTo('#pension .pension-bubble-one', 0.8, {y: '200%'}, {y: '-100%',  ease: Power2.easeOut}, 0)
		tween.fromTo('#pension .pension-bubble-two', 0.8, {y: '200%'}, {y: '-20%',  ease: Power2.easeOut}, 0)
		tween.fromTo('#pension .pension-bubble-three', 0.8, {y: '200%'}, {y: '-10%', opacity: 1, ease: Power2.easeOut}, 0)


		this.aboutMeScene = new ScrollMagic.Scene({
			triggerElement: '#pension',
			// triggerHook: 'onEnter',
			offset: 0,
			duration: '100%'
		})
		.setTween(tween)
		.addTo(this.controller)

		// this.aboutMeScene.addIndicators();

	},

	initEvelageScene(){
		var tween = new TimelineMax();

		tween.fromTo('#elevage h2', 0.6, {y: 20, opacity: 0}, {y: 0, opacity: 1, ease: Power2.easeOut})

		this.contentScene = new ScrollMagic.Scene({
			triggerElement: '#elevage',
			// triggerHook: 'onEnter',
			offset: 0,
		})
		.setTween(tween)
		.addTo(this.controller)

		// this.contentScene.addIndicators();

	},


	initHorsesScene(){
		var tween = new TimelineMax();

		tween.fromTo('#horses h2', 0.8, {y: 40, opacity: 0}, {y: '0%', opacity: 1, ease: Power2.easeOut})
		tween.staggerFromTo('#horses .front-horse', 0.6, {scale: 0, opacity: 0}, {scale: 1, opacity: 1, ease: Power2.easeOut }, 0.25, 0.2)
		tween.fromTo('#horses .nos-chevaux-left .btn', 0.4, {scale: 0.6, opacity: 0}, {scale: 1, opacity: 1, ease: Power2.easeOut}, 0.4)

		tween.fromTo('#horses .our-gallery-right-content', 0.6, {opacity: 0}, {opacity: 1, ease: Power2.easeOut}, 0)
		tween.fromTo('#horses .our-gallery-right h2', 0.8, {y: 40, opacity: 0}, {y: '0%', opacity: 1, ease: Power2.easeOut}, 0)
		tween.fromTo('#horses .our-gallery-right .btn', 0.4, {scale: 0.6, opacity: 0}, {scale: 1, opacity: 1, ease: Power2.easeOut}, 0.4)


		this.methodScene = new ScrollMagic.Scene({
			triggerElement: '#horses',
			// triggerHook: 'onEnter',
			offset: -50
		})
		.setTween(tween)
		.addTo(this.controller)

		// this.methodScene.addIndicators();

	},

	initSaleScene(){

		var tween = new TimelineMax();

		tween.fromTo('#vente h2', 0.8, {x: -40, opacity: 0}, {x: '0%', opacity: 1, ease: Power2.easeOut})
		tween.fromTo('#vente h3', 0.8, {x: -40, opacity: 0}, {x: '0%', opacity: 1, ease: Power2.easeOut}, 0.4)
		tween.staggerFromTo('#vente p', 0.6, {x: '-10%', opacity: 0}, {x: '0%', opacity: 1, ease: Power2.easeOut }, 0.25, 0.2)
		tween.fromTo('#vente .btn', 0.8, {y: 40, opacity: 0}, {y: '0%', opacity: 1, ease: Power2.easeOut}, 0.6)

		this.saleScene = new ScrollMagic.Scene({
			triggerElement: '#vente',
			// triggerHook: 'onEnter',
			offset: -50
		})
		.setTween(tween)
		.addTo(this.controller)

		// this.saleScene.addIndicators();

	}

}